import { useState, useEffect } from 'react'
import Card, { CardHeader } from '../ui/Card'
import SectionLabel from '../ui/SectionLabel'
import LoadingBear from '../ui/LoadingBear'
import { fetchEntities } from '../../api/client'

export default function EntitiesPanel() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchEntities().then(setData).finally(() => setLoading(false))
  }, [])

  if (loading) return <LoadingBear message="Mapping the constellation..." />

  return (
    <div>
      <SectionLabel>Panel 3 — Entity Map</SectionLabel>

      {/* Entity Force Graph - will be D3 canvas */}
      <Card delay={0.05}>
        <CardHeader title="Entity Map" badge={`${data?.count ?? 0} nodes`} badgeVariant="gold" />
        <div className="h-[500px] flex items-center justify-center rounded-lg bg-mm-parchment/[0.04]">
          <p className="text-mm-parchment/30 text-sm">D3 force-directed graph — coming in Phase 3</p>
        </div>
      </Card>

      {/* Context Distribution */}
      <Card delay={0.15} className="mt-4">
        <CardHeader title="Context Distribution" />
        <div className="space-y-3">
          {(data?.contexts ?? []).map((ctx) => (
            <div key={ctx.name} className="flex items-center gap-3">
              <span className="text-xs text-mm-parchment/50 w-24 text-right truncate">{ctx.name}</span>
              <div className="flex-1 h-2 bg-mm-border rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full"
                  style={{
                    width: `${ctx.pct}%`,
                    background: ctx.name === 'default'
                      ? 'var(--mm-persimmon)'
                      : 'linear-gradient(90deg, var(--mm-viridian), var(--mm-sage))',
                  }}
                />
              </div>
              <span className="text-xs font-glacial-bold text-mm-gold w-10">{ctx.pct}%</span>
            </div>
          ))}
        </div>
      </Card>
    </div>
  )
}
